"use strict";

var _interopRequireDefault = require("@babel/runtime/helpers/interopRequireDefault");

var _regenerator = _interopRequireDefault(require("@babel/runtime/regenerator"));

var _defineProperty2 = _interopRequireDefault(require("@babel/runtime/helpers/defineProperty"));

var _asyncToGenerator2 = _interopRequireDefault(require("@babel/runtime/helpers/asyncToGenerator"));

var _classCallCheck2 = _interopRequireDefault(require("@babel/runtime/helpers/classCallCheck"));

var _createClass2 = _interopRequireDefault(require("@babel/runtime/helpers/createClass"));

var _possibleConstructorReturn2 = _interopRequireDefault(require("@babel/runtime/helpers/possibleConstructorReturn"));

var _getPrototypeOf2 = _interopRequireDefault(require("@babel/runtime/helpers/getPrototypeOf"));

var _get3 = _interopRequireDefault(require("@babel/runtime/helpers/get"));

var _inherits2 = _interopRequireDefault(require("@babel/runtime/helpers/inherits"));

function ownKeys(object, enumerableOnly) { var keys = Object.keys(object); if (Object.getOwnPropertySymbols) { var symbols = Object.getOwnPropertySymbols(object); if (enumerableOnly) symbols = symbols.filter(function (sym) { return Object.getOwnPropertyDescriptor(object, sym).enumerable; }); keys.push.apply(keys, symbols); } return keys; }

function _objectSpread(target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i] != null ? arguments[i] : {}; if (i % 2) { ownKeys(source, true).forEach(function (key) { (0, _defineProperty2["default"])(target, key, source[key]); }); } else if (Object.getOwnPropertyDescriptors) { Object.defineProperties(target, Object.getOwnPropertyDescriptors(source)); } else { ownKeys(source).forEach(function (key) { Object.defineProperty(target, key, Object.getOwnPropertyDescriptor(source, key)); }); } } return target; }

var KeyValueStore = require('./keyValueStore');

var utils = require('./utils/index');

var PrivateStore =
/*#__PURE__*/
function (_KeyValueStore) {
  (0, _inherits2["default"])(PrivateStore, _KeyValueStore);

  function PrivateStore() {
    (0, _classCallCheck2["default"])(this, PrivateStore);
    return (0, _possibleConstructorReturn2["default"])(this, (0, _getPrototypeOf2["default"])(PrivateStore).apply(this, arguments));
  }

  (0, _createClass2["default"])(PrivateStore, [{
    key: "get",
    value: function () {
      var _get2 = (0, _asyncToGenerator2["default"])(
      /*#__PURE__*/
      _regenerator["default"].mark(function _callee(key) {
        var opts,
            entry,
            _args = arguments;
        return _regenerator["default"].wrap(function _callee$(_context) {
          while (1) {
            switch (_context.prev = _context.next) {
              case 0:
                opts = _args.length > 1 && _args[1] !== undefined ? _args[1] : {};
                _context.t0 = (0, _get3["default"])((0, _getPrototypeOf2["default"])(PrivateStore.prototype), "get", this);
                _context.t1 = this;
                _context.next = 5;
                return this._3id.hashDBKey(key);

              case 5:
                _context.t2 = _context.sent;
                _context.t3 = opts;
                _context.next = 9;
                return _context.t0.call.call(_context.t0, _context.t1, _context.t2, _context.t3);

              case 9:
                entry = _context.sent;

                if (entry) {
                  _context.next = 12;
                  break;
                }

                return _context.abrupt("return", null);

              case 12:
                if (!opts.metadata) {
                  _context.next = 21;
                  break;
                }

                _context.t4 = _objectSpread;
                _context.t5 = {};
                _context.t6 = entry;
                _context.next = 18;
                return this._decryptEntry(entry.value);

              case 18:
                _context.t7 = _context.sent;
                _context.t8 = {
                  value: _context.t7
                };
                return _context.abrupt("return", (0, _context.t4)(_context.t5, _context.t6, _context.t8));

              case 21:
                return _context.abrupt("return", this._decryptEntry(entry));

              case 22:
              case "end":
                return _context.stop();
            }
          }
        }, _callee, this);
      }));

      function get(_x) {
        return _get2.apply(this, arguments);
      }

      return get;
    }()
  }, {
    key: "getMetadata",
    value: function () {
      var _getMetadata = (0, _asyncToGenerator2["default"])(
      /*#__PURE__*/
      _regenerator["default"].mark(function _callee2(key) {
        return _regenerator["default"].wrap(function _callee2$(_context2) {
          while (1) {
            switch (_context2.prev = _context2.next) {
              case 0:
                _context2.t0 = (0, _get3["default"])((0, _getPrototypeOf2["default"])(PrivateStore.prototype), "getMetadata", this);
                _context2.t1 = this;
                _context2.next = 4;
                return this._3id.hashDBKey(key);

              case 4:
                _context2.t2 = _context2.sent;
                return _context2.abrupt("return", _context2.t0.call.call(_context2.t0, _context2.t1, _context2.t2));

              case 6:
              case "end":
                return _context2.stop();
            }
          }
        }, _callee2, this);
      }));

      function getMetadata(_x2) {
        return _getMetadata.apply(this, arguments);
      }

      return getMetadata;
    }()
  }, {
    key: "set",
    value: function () {
      var _set = (0, _asyncToGenerator2["default"])(
      /*#__PURE__*/
      _regenerator["default"].mark(function _callee3(key, value) {
        return _regenerator["default"].wrap(function _callee3$(_context3) {
          while (1) {
            switch (_context3.prev = _context3.next) {
              case 0:
                utils.throwIfUndefined(key, 'key');
                _context3.next = 3;
                return this._encryptEntry(value);

              case 3:
                value = _context3.sent;
                _context3.next = 6;
                return this._3id.hashDBKey(key);

              case 6:
                key = _context3.sent;
                return _context3.abrupt("return", (0, _get3["default"])((0, _getPrototypeOf2["default"])(PrivateStore.prototype), "set", this).call(this, key, value));

              case 8:
              case "end":
                return _context3.stop();
            }
          }
        }, _callee3, this);
      }));

      function set(_x3, _x4) {
        return _set.apply(this, arguments);
      }

      return set;
    }()
  }, {
    key: "setMultiple",
    value: function () {
      var _setMultiple = (0, _asyncToGenerator2["default"])(
      /*#__PURE__*/
      _regenerator["default"].mark(function _callee4(keys, values) {
        var _this = this;

        var dbKeys, encryptedValues;
        return _regenerator["default"].wrap(function _callee4$(_context4) {
          while (1) {
            switch (_context4.prev = _context4.next) {
              case 0:
                utils.throwIfNotEqualLenArrays(keys, values);
                _context4.next = 3;
                return Promise.all(keys.map(function (key) {
                  return _this._3id.hashDBKey(key);
                }, this));

              case 3:
                dbKeys = _context4.sent;
                _context4.next = 6;
                return Promise.all(values.map(this._encryptEntry, this));

              case 6:
                encryptedValues = _context4.sent;
                return _context4.abrupt("return", (0, _get3["default"])((0, _getPrototypeOf2["default"])(PrivateStore.prototype), "setMultiple", this).call(this, dbKeys, encryptedValues));

              case 8:
              case "end":
                return _context4.stop();
            }
          }
        }, _callee4, this);
      }));

      function setMultiple(_x5, _x6) {
        return _setMultiple.apply(this, arguments);
      }

      return setMultiple;
    }()
  }, {
    key: "remove",
    value: function () {
      var _remove = (0, _asyncToGenerator2["default"])(
      /*#__PURE__*/
      _regenerator["default"].mark(function _callee5(key) {
        return _regenerator["default"].wrap(function _callee5$(_context5) {
          while (1) {
            switch (_context5.prev = _context5.next) {
              case 0:
                utils.throwIfUndefined(key, 'key');
                _context5.next = 3;
                return this._3id.hashDBKey(key);

              case 3:
                key = _context5.sent;
                return _context5.abrupt("return", (0, _get3["default"])((0, _getPrototypeOf2["default"])(PrivateStore.prototype), "remove", this).call(this, key));

              case 5:
              case "end":
                return _context5.stop();
            }
          }
        }, _callee5, this);
      }));

      function remove(_x7) {
        return _remove.apply(this, arguments);
      }

      return remove;
    }()
    /**
     * Returns array of underlying log entries. In linearized order according to their Lamport clocks.
     * Useful for generating a complete history of all operations on store. Key is hashed, so key is
     * not available from the private store.
     *
     *  @example
     *  const log = store.log
     *  const entry = log[0]
     *  console.log(entry)
     *  // { op: 'PUT', key: ...., value: 'Botbot', timeStamp: '1538575416068' }
     *
     * @return    {Array<Object>}     Array of ordered log entry objects
     */

  }, {
    key: "log",
    value: function () {
      var _log = (0, _asyncToGenerator2["default"])(
      /*#__PURE__*/
      _regenerator["default"].mark(function _callee6() {
        var encLog, log, _iteratorNormalCompletion, _didIteratorError, _iteratorError, _iterator, _step, entry;

        return _regenerator["default"].wrap(function _callee6$(_context6) {
          while (1) {
            switch (_context6.prev = _context6.next) {
              case 0:
                _context6.next = 2;
                return (0, _get3["default"])((0, _getPrototypeOf2["default"])(PrivateStore.prototype), "log", this).call(this);

              case 2:
                encLog = _context6.sent;
                log = [];
                _iteratorNormalCompletion = true;
                _didIteratorError = false;
                _iteratorError = undefined;
                _context6.prev = 7;
                _iterator = encLog[Symbol.iterator]();

              case 9:
                if (_iteratorNormalCompletion = (_step = _iterator.next()).done) {
                  _context6.next = 28;
                  break;
                }

                entry = _step.value;
                _context6.t0 = log;
                _context6.t1 = Object;
                _context6.t2 = entry;

                if (!entry.value) {
                  _context6.next = 20;
                  break;
                }

                _context6.next = 17;
                return this._decryptEntry(entry.value);

              case 17:
                _context6.t3 = _context6.sent;
                _context6.next = 21;
                break;

              case 20:
                _context6.t3 = null;

              case 21:
                _context6.t4 = _context6.t3;
                _context6.t5 = {
                  value: _context6.t4
                };
                _context6.t6 = _context6.t1.assign.call(_context6.t1, _context6.t2, _context6.t5);

                _context6.t0.push.call(_context6.t0, _context6.t6);

              case 25:
                _iteratorNormalCompletion = true;
                _context6.next = 9;
                break;

              case 28:
                _context6.next = 34;
                break;

              case 30:
                _context6.prev = 30;
                _context6.t7 = _context6["catch"](7);
                _didIteratorError = true;
                _iteratorError = _context6.t7;

              case 34:
                _context6.prev = 34;
                _context6.prev = 35;

                if (!_iteratorNormalCompletion && _iterator["return"] != null) {
                  _iterator["return"]();
                }

              case 37:
                _context6.prev = 37;

                if (!_didIteratorError) {
                  _context6.next = 40;
                  break;
                }

                throw _iteratorError;

              case 40:
                return _context6.finish(37);

              case 41:
                return _context6.finish(34);

              case 42:
                return _context6.abrupt("return", log);

              case 43:
              case "end":
                return _context6.stop();
            }
          }
        }, _callee6, this, [[7, 30, 34, 42], [35,, 37, 41]]);
      }));

      function log() {
        return _log.apply(this, arguments);
      }

      return log;
    }()
  }, {
    key: "_encryptEntry",
    value: function () {
      var _encryptEntry2 = (0, _asyncToGenerator2["default"])(
      /*#__PURE__*/
      _regenerator["default"].mark(function _callee7(entry) {
        return _regenerator["default"].wrap(function _callee7$(_context7) {
          while (1) {
            switch (_context7.prev = _context7.next) {
              case 0:
                if (!(typeof entry === 'undefined')) {
                  _context7.next = 2;
                  break;
                }

                throw new Error('Entry to encrypt cannot be undefined');

              case 2:
                return _context7.abrupt("return", this._3id.encrypt(JSON.stringify(entry)));

              case 3:
              case "end":
                return _context7.stop();
            }
          }
        }, _callee7, this);
      }));

      function _encryptEntry(_x8) {
        return _encryptEntry2.apply(this, arguments);
      }

      return _encryptEntry;
    }()
  }, {
    key: "_decryptEntry",
    value: function () {
      var _decryptEntry2 = (0, _asyncToGenerator2["default"])(
      /*#__PURE__*/
      _regenerator["default"].mark(function _callee8(encObj) {
        return _regenerator["default"].wrap(function _callee8$(_context8) {
          while (1) {
            switch (_context8.prev = _context8.next) {
              case 0:
                _context8.t0 = JSON;
                _context8.next = 3;
                return this._3id.decrypt(encObj);

              case 3:
                _context8.t1 = _context8.sent;
                return _context8.abrupt("return", _context8.t0.parse.call(_context8.t0, _context8.t1));

              case 5:
              case "end":
                return _context8.stop();
            }
          }
        }, _callee8, this);
      }));

      function _decryptEntry(_x9) {
        return _decryptEntry2.apply(this, arguments);
      }

      return _decryptEntry;
    }()
  }]);
  return PrivateStore;
}(KeyValueStore);

module.exports = PrivateStore;